import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchemaV2NestedShapeValues,
  StepConfigEditorOverride,
} from '../../StepConfigEditorTypes';

/**
 * Line Chart configuration sections for the Configure tab
 */
export const LINE_CHART_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['axesSection', 'seriesSection', 'errorBarsSection'],
  axesSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['xAxisSection', 'yAxisSection'],
    xAxisSection: {
      displayName: 'X-axis',
      configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
    },
    yAxisSection: {
      displayName: 'Y-axis',
      configShapePath: ['chartConfig', 'parameters', 'yAxisColumnName'],
    },
  },
  seriesSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['seriesColumnName'],
    seriesColumnName: {
      displayName: 'Series',
      configShapePath: ['chartConfig', 'parameters', 'seriesColumnName'],
      fieldSettings: {
        allowSelectNull: true,
        noColumnSelectedText: 'None',
      },
    },
  },
  errorBarsSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['errorBarColumnName'],
    errorBarColumnName: {
      displayName: 'Error bar',
      configShapePath: ['chartConfig', 'parameters', 'errorBarColumnName'],
      fieldSettings: {
        allowSelectNull: true,
        noColumnSelectedText: 'None',
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;

/**
 * Line Chart style sections for the Style tab
 */
export const LINE_CHART_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['xAxisSection', 'yAxisSection'],
  xAxisSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'X-axis',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['xAxisScale'],
    xAxisScale: {
      displayName: 'Scale',
      configShapePath: ['chartConfig', 'parameters', 'xAxisScale'],
    },
  },
  yAxisSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Y-axis',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['yAxisScale', 'yAxisIncludesZero'],
    yAxisScale: {
      displayName: 'Scale',
      configShapePath: ['chartConfig', 'parameters', 'yAxisScale'],
    },
    yAxisIncludesZero: {
      configShapePath: ['chartConfig', 'parameters', 'yAxisIncludesZero'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Include 0',
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;
